// @ts-nocheck
import { ThemeAlias } from 'styled-components-in';
/**
 * Uptime Colors.
 */

const uptimeColors = {
  mainTheme: {
    primary: '#5f249f',
    secondary: '#7229c0',
    light: '#e9e0f7',
    background: '#F5F5FF',
  },
  menuColors: {
    mainMenu: {
      background: '',
      textColor: '',
      iconColor: '',
      hover: '',
      hoverActive: '',
      searchIcon: '',
      searchBorder: '',
      avatar: '',
      badgeIcon: {
        textColor: '',
        dotColor: '',
      },
    },
    secondaryMenu: {
      textColor: '',
      hover: '',
      active: '',
      focus: '',
    },
  },
  thirdPartyColors: {
    EVAIconButton: '',
    EVAIconBanner: '',
    chatASD: {
      heroLogoColor: '',
      bubbleBackgroundColor: '',
      bubbleIconColor: '',
      headerLogoColor: '',
      headerBackgroundColor: '',
      headerActionsButtons: '',
      scrollbarColor: '',
      sendButtonColor: '',
      actionCardColor: '',
      startChatButtonColor: '',
      closeConfirmChatButtonColor: '',
      closeCancelChatButtonColor: '',
      linkColor: '',
    },
  },
  dynamicForm: {
    stepperState: {
      active: '#5f249f',
      completed: '#01579B',
      disabled: '#7E7E7E',
    },
    deviceSelection: {
      eyeBrow: {
        background: '#E3E3E3',
      },
      grayScale: {
        specBackground: '#D9D9D9',
        cardSelected: '#EDEEF3',
        specLine1: '#E5E6EC',
        boxShadow: '#E9E9E9',
        specLine2: '#F3F3F3',
      },
    },
  },
  grayScales: {
    white: "#ffffff",
    lightGray: "#e6e6e6",
    lightBorder: "#e5e6ec",
    boxShadow: "#e9e9e9",
    grayishBackground: "#f0f0f0",
    grayish: "#fafafa",
    gray: "#bcbec0",
    darkGray: "#a7a9ac",
    darkerGray: "#737373",
    darkestGray: "#323232",
    black: "#000000",
  },
  generalColors: {
    mainBackGround: '',
    columnTitle: '#a7a9ac',
    majorOutageCard: '#541313',
    dialogTitle: { background: '#d9d9d6', color: '#000000DE' },
    state: {
      info: '#1890ff',
      warning: '#FFB600',
      success: {
        light: '#62c370',
        dark: '#2E7D32',
      },
      danger: {
        light: '#ef233c',
        dark: '#D32F2F',
      },
      disabled: '#737373',
    },
    icon: {
      enabled: '#5f249f',
      secondary: '',
      hover: '',
      pressed: '',
      smallCard: '#977dff',
    },
    button: {
      hyperlink: {
        enabled: '#5f249f',
        hover: '#5f249f',
        pressed: '',
      },
      link: {
        enabled: '#1f2020',
        hover: '#a7a9ac',
        pressed: '',
      },
      primary: {
        enabled: '#5f249f',
        hover: '#7229c0',
        pressed: '',
        text: ''
      },
      outline: {
        enabled: '',
        hover: '',
        pressed: '',
        text: ''
      },
      mobileSideSheet: {
        enabled: '#3300724d',
        hover: '#7229c0',
        pressed: '',
      },
    },
    footer: {
      background: '#F5F5FF',
      textColor: '',
      buttonColor: '',
    },
  },
  ticketColors: {
    chatTimeline: {
      user: { iconColor: '#5f249f', titleColor: '#5f249f' },
      other: { iconColor: '#67ae3f', titleColor: '#62c370' },
    },
    eyeBrow: {
      open: { background: '#E2F3DB', color: '#68BC46' },
      awaitingApproval: { background: '#6CC24A', color: '#FFFFFF' },
      closed: { background: '#A7A9C0', color: '#FFFFFF' },
      approved: { background: '#A7A9C0', color: '#FFFFFF' },
      rejected: { background: '#A7A9C0', color: '#FFFFFF' },
      resolved: { background: '#A7A9C0', color: '#FFFFFF' },
      submitted: { background: '#E2F3DB', color: '#68BC46' },
      cancelled: { background: '#A7A9C0', color: '#FFFFFF' },
      deviceInTransit: { background: '#f5f5ff', color: '#2B9702' },
      noLongerRequired: { background: '#A7A9C0', color: '#FFFFFF' },
      inProgress: { background: '#E2F3DB', color: '#68BC46' },
      pendingCancellation: { background: '#e9e0f7', color: '#5f249f' },
      approvalRejected: { background: '#A7A9C0', color: '#FFFFFF' },
      pcReturn: { background: '#e9e0f7', color: '#5f249f' },
      underInvestigation: { background: '#e9e0f7', color: '#5f249f' },
      orderingDevice: { background: '#ffe5cd', color: '#f57803' },
      preparingShippingMaterials: { background: '#e9e0f7', color: '#5f249f' },
      preparingDevice: { background: '#ffe5cd', color: '#f57803' },
      oemSubmitted: { background: '#e9e0f7', color: '#5f249f' },
    },
  },
  newsKnowledgeColors: {
    rating: '#5f249f',
    highlight: ['#FBEE94', '#E0B746', '#E65100'],
    eyeBrow: {
      announcements: { background: '#deecfd', color: '#1e67d8' },
      kbFiltering: { background: '#e9e0f7', color: '#5f249f' },
      kbFilteringOnHover: { background: '#977dff', color: '#ffffff' },
      majorOutages: { background: '#E40032', color: '#FFFFFF' },
      topKnowledgeArticle: { background: '#e9e0f7', color: '#5f249f' },
    },
  },
  deviceHealthEyebrow: {
    veryGood: { background: '#e8f5e9', color: '#2E7D32' },
    good: { background: '#e8f5e9', color: '#2E7D32' },
    average: { background: '#fff3e0', color: '#FF9800' },
    sufficient: { background: '#e1f5fe', color: '#01579B' },
    needAttention: { background: '#fff3e0', color: '#E65100' },
    poor: { background: '#ffebee', color: '#C62828' },
    veryPoor: { background: '#ffebee', color: '#C62828' },
    noData: { background: '#00000014', color: '#000000DE' },
  },
  deviceCardEyebrow: {
    active: { background: '#62c370', color: '#2B9702' },
    activity: { background: '#e9e0f7', color: '#5f249f' },
    inUse: { background: '#e9e0f7', color: '#5f249f' },
    deviceCard: { background: '#ffe5cd', color: '#f57803' },
    acknowledgeDevice: { background: '#ffe5cd', color: '#f57803' },
    exception: { ackground: '#ffe5cd', color: '#f57803' },
    excpOrderReq: { background: '#FEEBEE', color: '#C62828' },
  },
  marketplace: {
    heroSection: {
      background: '#e8eaf6',
      color: '#5F249F',
    },
  },
  textColors: {
    primary: '#000000DE',
    secondary: '#00000099',
  },
};

/**
 * Uptime Fonts name.
 */
const uptimeFonts = {
  primary: 'Open Sans',
  secondary: `'Segoe UI', 'Helvetica', 'Arial', 'sans-serif'`,
};

/**
 * Uptime Font sizes.
 *
 * Default values are based on a x1.125 scale.
 */
const uptimeFontSizes = {
  desktop: {
    fz1: 10,
    fz2: 12,
    fz3: 13,
    fz4: 14,
    fz5: 16,
    fz6: 18,
    fz7: 20,
    fz8: 22,
    fz9: 24,
    fz10: 28,
    fz11: 32,
    fz12: 36,
    fz13: 40,
  },
  mobile: {
    fz1: 10,
    fz2: 12,
    fz3: 13,
    fz4: 14,
    fz5: 16,
    fz6: 18,
    fz7: 22,
    fz8: 24,
    fz9: 28,
    fz10: 32,
  },
};

/**
 * Uptime Line heights.
 */
const uptimeLineHeights = {
  desktop: {
    lh1: 14,
    lh2: 16,
    lh3: 18,
    lh4: 20,
    lh5: 22,
    lh6: 24,
    lh7: 26,
    lh8: 28,
    lh9: 30,
    lh10: 32,
    lh11: 34,
  },
  mobile: {
    lh1: 14,
    lh2: 16,
    lh3: 18,
    lh4: 20,
    lh5: 22,
    lh6: 24,
    lh7: 26,
    lh8: 28,
    lh9: 30,
    lh10: 32,
    lh11: 34,
  },
};

/**
 * Uptime Spacing. For Padding, Margins
 */
/**                  0, 1, 2, 3, 4, 5,  6,  7,  8,  9,  10, 11, 12, 13, 14, 15  16  17  18  19  20*/
const uptimeSpace = [
  0,
  2,
  4,
  6,
  8,
  10,
  12,
  14,
  16,
  18,
  20,
  22,
  24,
  26,
  28,
  30,
  32,
  34,
  36,
  38,
  40,
];

const colors = {
  accent: ['#FFB600', '#00B5E2'],
  gradient: [
    ['#056ACA', '#053362'],
    ['#FFB600', '#FF8300'],
  ],
  grayScale: [
    '#FFFFFF',
    '#F8F8F9',
    '#F2F2F2',
    '#E6E6E6',
    '#CCCCCC',
    '#BCBEC0',
    '#A7A9AC',
    '#939598',
    '#808285',
    '#6D6E71',
    '#58595B',
    '#414042',
    '#000000',
  ],
  state: {
    success: '#2B9702',
    warning: '#F96806',
    danger: '#CE0E10',
    productPrimary: '#5F249F',
    active: '#00B5E2',
    onBlur: '#1E2F46',
    background: '#F4FAFF',
  },
  background: {
    enabled: '#FFFFFF',
    hover: '#F4FAFF',
    focus: '#E9F4FE',
    disabled: '#F2F2F2',
  },
  button: {
    primary: {
      enabled: '#7229c0',
      hover: '#5f249f',
      pressed: '#7229c0',
    },
    accent: {
      enabled: '#FFB600',
      hover: '#FF8300',
      pressed: '#A4541C',
    },
  },
  form: {
    text: {
      label: {
        enabled: '#0A2543',
        disabled: '#BCBEC0',
      },
      input: {
        placeholder: '#7E8BA5',
        enabled: '#0A2543',
        disabled: '#BCBEC0',
      },
      menu: {
        enabled: '#0A2543',
        hover: '#053362',
      },
    },
    input: {
      border: {
        enabled: '#053362',
        focus: '#056ACA',
        disabled: '#808285',
      },
      background: {
        enabled: '#F4FAFF',
        disabled: '#F2F2F2',
      },
    },
  },
  navigation: {
    dark: '#0A2543',
    bright: '#056ACA',
    medium: '#E9F4FE',
    light: '#F4FAFF',
    text: {
      dark: '#0A2543',
      light: '#F4FAFF',
      disabled: '#BCBEC0',
    },
  },
  primary: ['#5F249F', '#3E037D', '#7229C0', '#977DFF', '#E5DEEF', '#F6F3FC'],
  // secondary: ['#1F2020, #737373, #197FE5', '#07539F', '#D81E5B', '#F57803', '#FDDEE2', '#E9E0F7', '#FFE5CD', '#E0F3E2'],
  secondary: ['#1F2020', '#737373', '#BCBEC0'],
  impact: ['#0870D8', '#ffffff', '#0A5DB1'],
  backgroundColor: ['#FFFFFF', '#F4FAFF', '#F2F2F2'],
};

/**
 * Fonts.
 */
const fonts = {
  primary: 'Open Sans',
  secondary: 'Segoe UI',
};

/**
 * Font sizes.
 *
 * Default values are based on a x1.125 scale.
 */
const fontSizes = [14.3, 16, 18, 20.25, 22.8, 25.6, 28.8, 32.4, 36.5];

/**
 * Spacing. For Padding, Margins
 */
const space = [0, 4, 8, 12, 16, 24, 32, 40, 48, 64, 80, 96, 112, 128];

/**
 * Min container sizes
 */
const sizes = {
  xxs: '0px',
  xs: '375px',
  sm: '600px',
  md: '768px',
  lg: '1280px',
  xl: '1440px',
  xxl: '1920px',
};

/**
 * Radii.
 */
const radii = [0, 3, 6];

/**
 * Z-indices.
 */
const zIndices = [0, 100, 1000, 10000, 100000];

/**
 * Line heights.
 */
const lineHeights = [1, 1.25, 1.285, 1.44];

/**
 * Shadow values.
 */
const shadows = {
  xxs: '0 1px 1px 0 rgba(183, 183, 183, 0.3)',
  xs: '0 1px 1px 0 rgba(183, 183, 183, 0.3)',
  sm: '0 1px 3px 0 rgba(136, 136, 136, 0.3)',
  md: '0 2px 4px 0 rgba(0,0,0,0.1), 0 4px 8px 0 rgba(0,0,0,0.15)',
  lg:
    '0 2px 4px 0 rgba(0,0,0,0.05), 0 4px 5px 0 rgba(0,0,0,0.16), 0 7px 10px 0 rgba(0,0,0,0.18)',
  xl: '0 2px 4px 0 rgba(0,0,0,0.12), 0 14px 14px 0 rgba(0,0,0,0.12)',
  xxl: '0 3px 5px 0 rgba(0,0,0,0.12), 0 24px 16px 0 rgba(0,0,0,0.1)',
};

/**
 * Breakpoints
 */
const breakpoints: ThemeAlias = [
  '0px',
  '375px',
  '600px',
  '900px',
  '1280px',
  '1440px',
  '1920px',
];
[breakpoints.xxs] = breakpoints;
[, breakpoints.xs] = breakpoints;
[, , breakpoints.sm] = breakpoints;
[, , , breakpoints.md] = breakpoints;
[, , , , breakpoints.lg] = breakpoints;
[, , , , , breakpoints.xl] = breakpoints;
[, , , , , , breakpoints.xxl] = breakpoints;

const maxWidths: ThemeAlias = [
  '100%',
  '100%',
  '100%',
  '900px',
  '1280px',
  '1280px',
  '1280px',
];
[maxWidths.xxs] = maxWidths;
[, maxWidths.xs] = maxWidths;
[, , maxWidths.sm] = maxWidths;
[, , , maxWidths.md] = maxWidths;
[, , , , maxWidths.lg] = maxWidths;
[, , , , , maxWidths.xl] = maxWidths;
[, , , , , , maxWidths.xxl] = maxWidths;
/**
 * Gutters (in pixels)
 * Determines how much space to add between and
 * outside of grid columns;
 * Keys should match that of breakpoints
 */
const gutters: ThemeAlias = [16, 16, 24, 24, 24, 24, 24];
[gutters.xxs] = gutters;
[, gutters.xs] = gutters;
[, , gutters.sm] = gutters;
[, , , gutters.md] = gutters;
[, , , , gutters.lg] = gutters;
[, , , , , gutters.xl] = gutters;
[, , , , , , gutters.xxl] = gutters;

const margins: ThemeAlias = [
  '16px',
  '16px',
  '24px',
  'auto',
  'auto',
  'auto',
  'auto',
];
[margins.xxs] = margins;
[, margins.xs] = margins;
[, , margins.sm] = margins;
[, , , margins.md] = margins;
[, , , , margins.lg] = margins;
[, , , , , margins.xl] = margins;
[, , , , , , margins.xxl] = margins;

const layout = {
  home: {
    newsAndKnowledgeCol: {
      xxs: 12,
      xs: 12,
      sm: 12,
      md: 8,
      lg: 6,
      xl: 6,
      xxl: 6,
    },
    myTechnologyCol: {
      xxs: 12,
      xs: 12,
      sm: 12,
      md: 4,
      lg: 3,
      xl: 3,
      xxl: 3,
    },
    mySupportCol: {
      xxs: 12,
      xs: 12,
      sm: 12,
      md: 12,
      lg: 3,
      xl: 3,
      xxl: 3,
    },
  },
};

const gridSpacing = {
  xxs: 1,
  xs: 1,
  sm: 1,
  md: 1,
  lg: 1,
  xl: 1,
  xxl: 1,
};

const marketplaceGridSpacing = {
  xxs: 2,
  xs: 2,
  sm: 2,
  md: 3,
  lg: 3,
  xl: 3,
  xxl: 3,
};

const marketplaceColors = {
  primary: {
    main: '#5F249F80',
  },
  gray: {
    1: '#ffffff',
    2: '#F5F5F5',
    3: '#EEEEEE',
    4: '#0000001F',
    5: '#0000003b',
    6: '#00000033',
    7: '#00000040',
    8: '#0000008F',
    9: '#00000099',
    10: '#000000DE',
    11: '#9E9E9E',
    12: '#00000024',
    13: '#0000000a',
  },
  background: {
    1: '#EDE7F6',
    2: '#5F249F14',
    3: '#E8EAF6',
    4: '#fafafa',
    5: '#00000014',
    6: '#fefefe',
    7: '#F5F5FF',
    8: '#5F249F0A',
  },
  state: {
    completed: '#2E7D32',
    cancelled: '#D32F2F',
  },
  text: {
    primary: '#000000DE',
    secondary: '#00000099',
  },
};

const uptimeDynamicAlignCenter = {
  topKnowledgeArticles: {
    marginBottomViewCountAndLastUpdate: "0px",
    marginBottomTitle: "0px"
  },
  columnTitle: {
    lineHeight: "1.25"
  },
  eyebrow: {
    paddingTop: "0px"
  },
  activityCardSmallBox: {
    paddingTop: "0px"
  },
  button: {
    paddingTop: "8px"
  },
  viewMoreArrow: {
    marginTop: "-11px"
  },
  backBtn: {
    paddingTop: "2px"
  },
  avatarASDChat: {
    paddingTop: "4px"
  },
  avatarComments: {
    lineHeight: "18px"
  },
  avatarUser: {
    paddingTop: "0px"
  },
  searchBoxHomePage: {
    marginTop: "15px"
  },
  menuItem: {
    marginTop: "2px"
  },
  submenuItem: {
    paddingTop: "11px"
  },
  marketplace: {
    eyebrow: {
      paddingTop: "0"
    },
  },
  quickLink: {
    card: {
      width: "100%",
      height: "146px",
      padding: `${uptimeSpace[6]}px`,
      minWidth: "",
    },
    icon: {
      height: "33px",
      padding: `${uptimeSpace[2]}px ${uptimeSpace[4]}px ${uptimeSpace[2]}px 0`
    },
    textWrapper: {
      justifyContent: "space-between",
      marginTop: `${uptimeSpace[2]}px`
    },
    title: {
      marginTop: "0px",
      lineHeight: "20px",
      minHeight: "fit-content",
      letterSpacing: "-0.5px",
      maxLines: 2,
    },
    subTitle: {
      marginTop: "0px",
      lineHeight: "15px",
      letterSpacing: "-0.2px",
      maxLines: 2,
    },
    lineHeightButtonLink: "1"
  },
  newsAndKnowledge: {
    outage: {
      lineHeightTitle: "1.375em",
      lineHeightContent: "1.2em"
    },
    announcements: {
      lineHeightTitle: "25px",
      lineHeightContent: "18px"
    }
  },
  deviceAndAcknowledgeCard: {
    lineHeightBrand: "18px",
    lineHeightName: "initial",
    lineHeightConfigItem: "18px",
    lineHeightBodyStatus: "18px",
    marginTopLinkText: "0px"
  },
  knowledgeArticlesPage: {
    filterComponent: {
      listItem: {
        paddingTop: "10px"
      },
      subListItem: {
        paddingTop: "1px"
      },
      showMoreBtn: {
        paddingTop: "1px"
      }
    },
    sortComponent: {
      inputBase: {
        paddingTop: "1px"
      },
      selectBoxItem: {
        paddingTop: "1px"
      }
    },
    filteringEyebrow: {
      paddingTop: "1px"
    },
    accordionTicket: {
      title: {
        marginBottom: "1px"
      }
    },
    pagination: {
      paddingTop: "1px"
    }
  },
  supportPage: {
    searchBox: {
      marginTop: "8px",
      marginBottom: "8px"
    },
    ticketPrefix: {
      top: "36px"
    }
  }
};

const uptimeDynamicFontSize = {
  eyeBrow: `${uptimeFontSizes.desktop.fz2}px`,
  hyperLink: `${uptimeFontSizes.desktop.fz4}px`,
  titleColumn: `${uptimeFontSizes.desktop.fz6}px`,
  outageCard: {
    lastUpdate: `${uptimeFontSizes.desktop.fz2}px`,
    title: `${uptimeFontSizes.desktop.fz7}px`,
    desc: `${uptimeFontSizes.desktop.fz2}px`,
  },
  announcementsCard: {
    title: `${uptimeFontSizes.desktop.fz7}px`,
    desc: `${uptimeFontSizes.desktop.fz2}px`,
  },
  kbArticleCard: {
    title: `${uptimeFontSizes.desktop.fz5}px`,
    viewCount: `${uptimeFontSizes.desktop.fz2}px`,
    lastUpdate: `${uptimeFontSizes.desktop.fz2}px`,
  },
  deviceCard: {
    manufacturer: `${uptimeFontSizes.desktop.fz2}px`,
    deviceName: `${uptimeFontSizes.desktop.fz7}px`,
    desc: `${uptimeFontSizes.desktop.fz2}px`,
    infoDevice: `${uptimeFontSizes.desktop.fz2}px`,
    txtBtn: `${uptimeFontSizes.desktop.fz2}px`,
    txtLink: `${uptimeFontSizes.desktop.fz4}px`,
  },
  myOpenCard: {
    totalTicket: `${uptimeFontSizes.desktop.fz9}px`,
    typeTicket: `${uptimeFontSizes.desktop.fz2}px`,
  },
  quickLinkCard: {
    title: `${uptimeFontSizes.desktop.fz5}px`,
    subTitle: `${uptimeFontSizes.desktop.fz3}px`,
  },
  bannerCard: {
    txtChatBtn: `${uptimeFontSizes.desktop.fz4}px`,
  },
};

const uptimeTextTransform = {
  button: ''
};

const DefaultUptimeTheme = {
  uptimeColors,
  uptimeFonts,
  uptimeFontSizes,
  uptimeLineHeights,
  uptimeSpace,
  uptimeDynamicFontSize,
  colors,
  fonts,
  fontSizes,
  sizes,
  space,
  zIndices,
  radii,
  lineHeights,
  shadows,
  breakpoints,
  gutters,
  maxWidths,
  layout,
  margins,
  marketplaceColors,
  gridSpacing,
  marketplaceGridSpacing,
  uptimeDynamicAlignCenter,
  uptimeTextTransform,
};

export default DefaultUptimeTheme;
